export const EMAIL_FOOTER_PLACEHOLDER = '<!-- Footer -->';

export function getEmailFooter(emailPreferencesLink: string) {
  return `<div class="footer"
            style="font-family: 'Helvetica Neue',Helvetica,Arial,sans-serif; box-sizing: border-box; font-size: 14px; width: 100%; clear: both; color: #999; margin: 0; padding: 20px;">
            <table width="100%"
                style="font-family: 'Helvetica Neue',Helvetica,Arial,sans-serif; box-sizing: border-box; font-size: 14px; margin: 0;">
                <tr
                    style="font-family: 'Helvetica Neue',Helvetica,Arial,sans-serif; box-sizing: border-box; font-size: 14px; margin: 0;">
                    <td class="aligncenter content-block"
                        style="font-family: 'Helvetica Neue',Helvetica,Arial,sans-serif; box-sizing: border-box; font-size: 12px; vertical-align: top; color: #999; text-align: center; margin: 0; padding: 0 0 20px;"
                        align="center" valign="top">Follow <a href="https://twitter.com/@joinwaterlily"
                            style="font-family: 'Helvetica Neue',Helvetica,Arial,sans-serif; box-sizing: border-box; font-size: 12px; color: #999; text-decoration: underline; margin: 0;">@joinwaterlily</a>
                        on Twitter.
                    </td>
                    <td class="aligncenter content-block"
                        style="font-family: 'Helvetica Neue',Helvetica,Arial,sans-serif; box-sizing: border-box; font-size: 12px; vertical-align: top; color: #999; text-align: center; margin: 0; padding: 0 0 20px;"
                        align="center" valign="top"><a href="${emailPreferencesLink}"
                            style="font-family: 'Helvetica Neue',Helvetica,Arial,sans-serif; box-sizing: border-box; font-size: 12px; color: #999; text-decoration: underline; margin: 0;">Unsubscribe</a>
                        </td>
                </tr>
            </table>
        </div>`;
}

// Placeholder + footer for redesigned React Email templates. Legacy string
// templates keep EMAIL_FOOTER_PLACEHOLDER/getEmailFooter above, untouched.
export const EMAIL_FOOTER_MODERN_PLACEHOLDER = '<!-- FooterModern -->';

export const WATERLILY_TWITTER_URL = 'https://twitter.com/joinwaterlily';
export const WATERLILY_LINKEDIN_URL =
  'https://www.linkedin.com/company/waterlily-care-planning';

// The modern footer itself is a React Email component:
// see packages/shared/src/email/react/ModernEmailFooter.tsx
